import React from 'react';
import { Layout, PageHeader } from '../Layout';
import { EmptyStateCard } from './EmptyStateCard';
import { LayoutProps } from '../Layout/Layout';
import { EmptyStateProps } from './EmptyState';

export interface EmptyViewProps extends EmptyStateProps {
    title: React.ReactNode;
    titleIcon?: React.ReactElement;
    layoutProps?: Partial<LayoutProps>;
}

export const EmptyView: React.FunctionComponent<EmptyViewProps> = props => {
    return (
        <Layout
            header={
                <PageHeader
                    title={props.title}
                    icon={props.titleIcon}
                />
            }
            width={500}
            {...(props.layoutProps || {})}
        >
            <EmptyStateCard
                icon={props.icon}
                iconRenderer={props.iconRenderer}
            >
                {props.children}
            </EmptyStateCard>
        </Layout>
    );
};
